import Alpha from './Alpha.jsx';

export default Alpha;